import React from 'react';

const Terms: React.FC = () => {
  return (
    <>
      {/* JSON-LD SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms & Conditions - SpinTitanium",
            "description": "Terms and conditions for using SpinTitanium's website and services.",
            "url": "https://spintitanium.com/terms"
          })
        }}
      />

      <div className="min-h-screen bg-titanium-950 pt-20 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">
            <span className="text-gradient">Terms & Conditions</span>
          </h1>
          <p className="text-gray-400 mb-8">Last updated: December 2025</p>

          <div className="glass rounded-xl p-8 border-2 border-titanium-800 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                By accessing and using spintitanium.com ("the Website"), you accept and agree to be bound by 
                these Terms and Conditions. If you do not agree to these terms, please do not use our website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Age Restriction</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                You must be at least 18 years old to use this website. By using the Website, you represent 
                and warrant that you are 18 years of age or older. We reserve the right to verify your age 
                at any time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Use of Website</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                You agree to use the Website only for lawful purposes and in a way that does not infringe 
                the rights of, restrict, or inhibit anyone else's use of the Website. Prohibited behavior 
                includes:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
                <li>Harassing or causing distress to any person</li>
                <li>Transmitting obscene or offensive content</li>
                <li>Disrupting the normal flow of dialogue</li>
                <li>Attempting to gain unauthorized access to any part of the Website</li>
                <li>Using the Website for any commercial purpose without our written consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Content and Information</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                While we strive to provide accurate and up-to-date information, we make no warranties or 
                representations about the accuracy, completeness, or suitability of the information on this 
                website. Casino bonuses, terms, and conditions may change without notice. Always verify 
                current terms directly with the casino operator.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Affiliate Relationships</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                SpinTitanium has affiliate relationships with many casino operators. This means we may receive 
                a commission when you sign up or make a deposit through our links. This does not affect the 
                price you pay or the terms you receive from the casino. Our reviews remain independent and 
                honest regardless of affiliate relationships.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Responsible Gambling</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                We promote responsible gambling. If you feel you may have a gambling problem, please seek 
                help from organizations such as GamCare (www.gamcare.org.uk) or GambleAware 
                (www.gambleaware.org). We are not responsible for any losses incurred through gambling.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Intellectual Property</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                All content on this website, including text, graphics, logos, images, and software, is the 
                property of SpinTitanium or its content suppliers and is protected by copyright and other 
                intellectual property laws. You may not reproduce, distribute, or create derivative works 
                from any content without our express written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Third-Party Links</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Our website contains links to third-party websites, including casino operators. We are not 
                responsible for the content, privacy policies, or practices of these external sites. Your 
                use of third-party websites is at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Limitation of Liability</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                To the fullest extent permitted by law, SpinTitanium shall not be liable for any indirect, 
                incidental, special, consequential, or punitive damages, or any loss of profits or revenues, 
                whether incurred directly or indirectly, or any loss of data, use, goodwill, or other 
                intangible losses resulting from your use of the Website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Indemnification</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                You agree to indemnify and hold harmless SpinTitanium, its officers, directors, employees, 
                and agents from any claims, damages, losses, liabilities, and expenses (including legal fees) 
                arising out of or relating to your use of the Website or violation of these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Changes to Terms</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                We reserve the right to modify these Terms at any time. We will notify users of any material 
                changes by posting the updated Terms on this page and updating the "Last updated" date. Your 
                continued use of the Website after such changes constitutes acceptance of the new Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">12. Governing Law</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                These Terms shall be governed by and construed in accordance with the laws of England and Wales. 
                Any disputes arising from these Terms or your use of the Website shall be subject to the 
                exclusive jurisdiction of the courts of England and Wales.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">13. Contact Information</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                If you have any questions about these Terms, please contact us at:
              </p>
              <p className="text-gray-300 leading-relaxed">
                Email: legal@spintitanium.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;


